module.exports = __webpack_public_path__ + "static/media/relax.9e2f7daf.svg";